module.exports = __webpack_public_path__ + "img/pause.1278b966.svg";